module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    attrs: {
      "modifier": "secondary"
    }
  }, [_c('v-ons-button', {
    attrs: {
      "modifier": "light back"
    },
    on: {
      "click": _vm.backToTop
    }
  }, [_vm._v("\n    戻る\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "food_menu"
  }, [_c('v-ons-row', [_c('v-ons-col', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "img1"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/menu1.jpg")
    }
  })])]), _vm._v(" "), _c('v-ons-col', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "img2"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/menu2.jpg")
    }
  })])])], 1), _vm._v(" "), _c('v-ons-row', [_c('v-ons-col', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "img3"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/menu3.jpg")
    }
  })])]), _vm._v(" "), _c('v-ons-col', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "img4"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/menu4.jpg")
    }
  })])])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46f5d4ac","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/private/food_menu.vue
// module id = 553
// module chunks = 0